
import "./loader.css"
export default function Loader() {
    return (
        <>

            <div className="w-full h-[50vh] flex justify-center z-[99999] items-center">
                <div className="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
            </div>
        </>
    )
}
